<template>
   <div style="height:100%">
       <div id="contrain">
            <div class="toolbar">
            <span>缓冲半径：</span>
            <input type="number" v-model="inputdata" value="1" min="1" step="1" class="form-control" style="width:100px">（公里）
            <input type="button" value="点"  class="btn btn-primary" @click="drawpoint()">
            <input type="button" value="线" class="btn btn-primary"  @click="drawline()">
            <input type="button" value="面" class="btn btn-primary"  @click="drawpolygon()">
            <input type="button" value="删除" class="btn btn-primary"  @click="dele()">
            </div>
       </div>
       <div id="loadingOverlay"><h1>Loading........</h1></div>
   </div>
</template>
<script>
import util from "../../components/util"
const turf = require('@turf/turf')
export default {
    data () {
        return {
            viewer:null,
            inputdata:15,
            drawingMode :'line',
            activeShapePoints : [],
            activeShape:null,
            floatingPoint:null,
            bufferpoin:[],
            poins:[],
            buffered:null,
            point:null,
            earthPositionline:null,
            Positionpoly:null,
            pointline:[],
            linepontes:[],
            linees:null,
            linebuff:[],
            polypoin:[],
            polypoins:[],
            polyes:null,
            polybuff:[],
        }
    },
    watch:{
        inputdata(val){
        //   this.drawpoint(val);
        }
    },
    mounted(){
        var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
        this.init();
    },
    methods: {
        init() {
             if(this.$device !== 'pc'){
                    this.$message({
                        showClose: true,
                        message: '手机端由于绘制机制暂未开放，请用电脑端使用该功能。',
                        duration: 10000
                    });
                }
             this.viewer=util.getViewer("contrain",{
                // terrainProvider: Cesium.createWorldTerrain()
             });
             this.viewer.camera.setView({
                 destination: Cesium.Cartesian3.fromDegrees(-100.0, 40.0, 900000.0)
               })
            },

         createPoint(worldPosition) {
            var point = this.viewer.entities.add({
                position : worldPosition,
                point : {
                    color : Cesium.Color.YELLOW,
                    pixelSize : 5,
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
                }
            });
            return point;
        },

         drawShape(positionData) {
            var shape;
            if (this.drawingMode === 'line') {
                shape = this.viewer.entities.add({
                    polyline : {
                        positions : positionData,
                        clampToGround : true,
                        width : 3,
                        material:Cesium.Color.YELLOW
                    }
                });
            }
            else if (this.drawingMode === 'polygon') {
                shape = this.viewer.entities.add({
                    polygon: {
                        hierarchy: positionData,
                        material: new Cesium.ColorMaterialProperty(Cesium.Color.YELLOW.withAlpha(0.7)),
                        fill:true,
                        outline:true,
                        outlineColor: Cesium.Color.RED,
                        outlineWidth:1
                    }
                });
            }
            return shape;
        },

        terminateShape() {
            this.activeShapePoints.pop();
            this.drawShape(this.activeShapePoints);
            this.viewer.entities.remove(this.floatingPoint);
            this.viewer.entities.remove(this.activeShape);
            this.floatingPoint = null;
            this.activeShape = null;
            this.activeShapePoints = [];
         },
         //****************************画点************************************************//
        drawpoint(positiondata){
            this.$message({
                    message: '鼠标左击绘制完成',
                });
            this.viewer.entities.removeAll();
            // this.viewer.terrainProvider =   new Cesium.EllipsoidTerrainProvider({});
            this.terminateShape();
            var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
            this.viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
            handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
            handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
            var that=this;
            handler.setInputAction((event)=>{
                let ray = that.viewer.camera.getPickRay(event.position);
                let   earthPosition = that.viewer.scene.globe.pick(ray, that.viewer.scene);
                // var cartesian = that.viewer.scene.globe.pick(that.viewer.camera.getPickRay(earthPosition),that.viewer.scene);
                that.viewer.entities.add({
                    position:earthPosition,
                    point:{
                        color : Cesium.Color.YELLOW,
                        pixelSize : 10,
                       }
                })
                handler.destroy();
                let ab12 = that.viewer.scene.globe.ellipsoid.cartesianToCartographic(earthPosition);
                let a = Cesium.Math.toDegrees(ab12.latitude);
                let b =  Cesium.Math.toDegrees(ab12.longitude);
                that.point = turf.point([b,a]);
                 that.buffered = turf.buffer(that.point, this.inputdata, {units: 'kilometers'});
                for(var i=0;i<that.buffered.geometry.coordinates[0].length-1;i++){
                         that.bufferpoin.push(that.buffered.geometry.coordinates[0][i]);
                         that.poins.push(that.bufferpoin[i][0],that.bufferpoin[i][1])
                    }
                let ab = that.viewer.entities.add({
                       polygon:{
                        hierarchy: Cesium.Cartesian3.fromDegreesArray(that.poins ),
                        arcType: Cesium.ArcType.RHUMB,
                        material: Cesium.Color.RED
                       }
                  })
                 that.terminateShape();
                 that.buffered=null;
                 that.bufferpoin=[];
                 that.poins=[];
            },Cesium.ScreenSpaceEventType.LEFT_CLICK)
        },

        //****************************画线************************************************//
        drawline(positiondata){
            this.$message({
                    message: '鼠标左击开始绘制，鼠标右击结束绘制',
                });
            this.viewer.entities.removeAll();
            this.linepontes = [],
            this.linees = null,
            this.linebuff= [],
            this.terminateShape();
            this.drawingMode='line';
            this.viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
            var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
            handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
            handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
            var that=this;
            handler.setInputAction((event)=> {
                // We use `viewer.scene.pickPosition` here instead of `viewer.camera.pickEllipsoid` so that
                // we get the correct point when mousing over terrain.
                    // event.position.x=event.position.x-left;
                    // event.position.y=event.position.y-top;
                var ray = that.viewer.camera.getPickRay(event.position);
                that.earthPositionline = that.viewer.scene.globe.pick(ray, that.viewer.scene);
                if (Cesium.defined(that.earthPositionline)) {
                    if (that.activeShapePoints.length === 0) {
                        that.floatingPoint = that.createPoint(that.earthPositionline);
                        that.activeShapePoints.push(that.earthPositionline);
                        var dynamicPositions = new Cesium.CallbackProperty(function () {
                           return that.activeShapePoints;
                        }, false);
                        that.activeShape = that.drawShape(dynamicPositions);
                    }
                    that.activeShapePoints.push(that.earthPositionline);
                    that.createPoint(that.earthPositionline);
                };
                var cd = that.viewer.scene.globe.ellipsoid.cartesianToCartographic(that.earthPositionline);
                var c = Cesium.Math.toDegrees(cd.latitude);
                var d =  Cesium.Math.toDegrees(cd.longitude);
                 that.pointline.push([d,c]);
            }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

            handler.setInputAction((event)=> {
                if (Cesium.defined(that.floatingPoint)) {
                    // var newPosition = that.viewer.scene.pickPosition(event.endPosition);
                    let ray = that.viewer.camera.getPickRay(event.endPosition);
                    let   newPosition = that.viewer.scene.globe.pick(ray, that.viewer.scene);
                    if (Cesium.defined(newPosition)) {
                        that.floatingPoint.position.setValue(newPosition);
                        that.activeShapePoints.pop();
                        that.activeShapePoints.push(newPosition);
                    }
                }
            }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
            var that=this;
            handler.setInputAction((event)=> {
                that.terminateShape();
                that.linees  =  turf.lineString(that.pointline);
                var buffered = turf.buffer( that.linees , 20, {units: 'kilometers'});
                     for(var i=0;i<buffered.geometry.coordinates[0].length;i++){
                         that.linepontes.push(buffered.geometry.coordinates[0][i]);
                         that.linebuff.push(that.linepontes[i][0],that.linepontes[i][1])
                    };
                    that.viewer.entities.add({
                      polygon : {
                        hierarchy :Cesium.Cartesian3.fromDegreesArray(that.linebuff),
                        clampToGround : true,
                        material: new Cesium.ColorMaterialProperty(Cesium.Color.RED.withAlpha(0.5))
                    },
                 });
                  that.pointline=[];
                  that.linebuff=[];
                  that.linees=null;
                  that.terminateShape();
                  handler.destroy();
            }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
        },

        //****************************画面************************************************//
        drawpolygon(positiondata){
            this.$message({
                    message: '鼠标左击开始绘制，鼠标右击结束绘制',
                });
            this.viewer.entities.removeAll()
            this. polypoin=[];
            this.polyes=null;
            this.polybuff=[];
            this.linepontes=[];
            this.terminateShape();
            this.drawingMode='polygon';
            this.viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
            var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
            var that=this;
            handler.setInputAction((event)=> {
                // We use `viewer.scene.pickPosition` here instead of `viewer.camera.pickEllipsoid` so that
                // we get the correct point when mousing over terrain.
                // var earthPosition = that.viewer.scene.pickPosition(event.position);
                let ray = that.viewer.camera.getPickRay(event.position);
                that.Positionpoly = that.viewer.scene.globe.pick(ray, that.viewer.scene);
                // `earthPosition` will be undefined if our mouse is not over the globe.
                if (Cesium.defined( that.Positionpoly)) {
                    if (that.activeShapePoints.length === 0) {
                        that.floatingPoint = that.createPoint( that.Positionpoly);
                        that.activeShapePoints.push( that.Positionpoly);
                        var dynamicPositions = new Cesium.CallbackProperty(function () {
                           return new Cesium.PolygonHierarchy(that.activeShapePoints);
                        }, false);
                        that.activeShape = that.drawShape(dynamicPositions);
                    }
                    that.activeShapePoints.push( that.Positionpoly);
                    that.createPoint( that.Positionpoly);
                };
                var ef = that.viewer.scene.globe.ellipsoid.cartesianToCartographic(that.Positionpoly);
                var e = Cesium.Math.toDegrees(ef.latitude);
                var f =  Cesium.Math.toDegrees(ef.longitude);
                that.polypoin.push([f,e]);
            }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
            handler.setInputAction((event)=> {
                if (Cesium.defined(that.floatingPoint)) {
                    // var newPosition = that.viewer.scene.pickPosition(event.endPosition);
                    let ray = that.viewer.camera.getPickRay(event.endPosition);
                    let   newPosition = that.viewer.scene.globe.pick(ray, that.viewer.scene);
                    if (Cesium.defined(newPosition)) {
                        that.floatingPoint.position.setValue(newPosition);
                        that.activeShapePoints.pop();
                        that.activeShapePoints.push(newPosition);
                    }
                }
            }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
            var that=this;
            handler.setInputAction((event)=> {
                handler.destroy();
                that.polypoin.push(that.polypoin[0]);
                that.polyes  = turf.polygon([that.polypoin]);
                var buffered = turf.buffer( that.polyes , 20, {units: 'kilometers'});
                     for(var i=0;i<buffered.geometry.coordinates[0].length;i++){
                         that.linepontes.push(buffered.geometry.coordinates[0][i]);
                         that.polybuff.push(that.linepontes[i][0],that.linepontes[i][1])
                    }
                    that.viewer.entities.add({
                      polygon : {
                        hierarchy :Cesium.Cartesian3.fromDegreesArray(that.polybuff),
                        clampToGround : true,
                        material: new Cesium.ColorMaterialProperty(Cesium.Color.RED.withAlpha(0.5))
                    },
                 });
                  that.terminateShape();
                  that.polypoin=[];
                  buffered={};
                  that.polybuff=[];
                  that.polyes =null;
            }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
        },

        dele(){
            var that=this;
            that.viewer.entities.removeAll();
        }
    },
}
</script>
<style scoped>
 #contrain{
    height: 100%;
 }
 .toolbar{
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    width:260px;
    height: 80px;
    top: 10px;
    left: 10px;
    padding: 10px 15px;
    border-radius: 4px;
    border: 1px solid rgba(128,128,128,.5);
    color: #fff;
    background: rgba(0,0,0,.4);
    box-shadow: 0 3px 14px rgba(128,128,128,.5);
    z-index: 100;
 }
 .form-control{
    color: #fff;
    background-color: rgba(63,72,84,.7);
    border: none;
 }
 .btn-primary{
    color:#fff;
    background-color: rgba(32,160,255,.2);
    cursor: pointer;
    margin:10px 13px 2px 2px;
    border: 1px solid #e4eaec;
    border-radius: 3px;
 }
</style>
